import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3c7ca310&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=3c7ca310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ca310",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/client-settings/footer.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2FFooter.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports